module.exports = {
  hierarchy : {},
  props : {
    default : {
      selectIcon : 'fa fa-chevron-down'
    }
  }
}
